type ContainerType = {
	isSmallScreen: boolean;
};

export const containerWrapper = ({ isSmallScreen }: ContainerType) => ({
	padding: isSmallScreen ? '2rem 1.5rem' : '3.75rem 3.75rem 2rem 3.75rem',
	borderTopRightRadius: isSmallScreen ? 0 : '0.5rem',
	borderBottomRightRadius: isSmallScreen ? 0 : '0.5rem',
	display: 'flex',
	flexDirection: 'column',
	gap: '1.25rem',
	maxWidth: '43.75rem',
	margin: '0 auto',
	alignItems: 'center',
});
